import { storeMixin, storeGenerator } from '@/storeMixin'
import { merge } from 'lodash'

const taskComment = merge(storeMixin.getMixin(), {
  state: {
    apiUrl: '/api/v1/task/{profile}/task-comment',
    app: 'task',
    pk: 'id'
  }
})

const TYPES = (() =>
  merge(
    storeGenerator(
      { profile: 'GENERIC', app: 'task', model: 'task-comment' }
    ),
    { }
  )
)()

export { taskComment, TYPES }
